import { Link } from '@tanstack/react-router';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@fade/ui';

import { useRandom } from '../lib/queries/feed';

export function RandomPage() {
  const { data, isPending, error, refetch, isRefetching } = useRandom();

  return (
    <main className="mx-auto max-w-2xl px-6 py-16">
      <header className="mb-8 flex items-center justify-between">
        <h1 className="font-serif text-3xl font-light">A story at random</h1>
        <Button variant="secondary" onClick={() => refetch()} disabled={isRefetching}>
          {isRefetching ? 'Finding…' : 'Another one'}
        </Button>
      </header>

      {isPending ? (
        <p className="text-muted-foreground">Finding a story…</p>
      ) : error ? (
        <p className="text-destructive">Failed to load.</p>
      ) : !data ? (
        <Card>
          <CardHeader>
            <CardTitle>Nothing here yet</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              No one has published a story yet. Check back later, or be the first.
            </p>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>
              <Link to="/legacies/$id" params={{ id: data.id }} className="hover:underline">
                {data.title}
              </Link>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="whitespace-pre-wrap font-serif text-base leading-relaxed text-foreground/90">
              {data.body}
            </p>
          </CardContent>
        </Card>
      )}
    </main>
  );
}